import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faSync, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
import './UnidadesData.css';
import baseURL from '../../url';

export default function UnidadesData() {
    const [unidades, setUnidades] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [unidadActual, setUnidadActual] = useState({});
    const [nombre, setNombre] = useState('');
    const [simbolo, setSimbolo] = useState('');
    const [filtro, setFiltro] = useState('');

    useEffect(() => {
        cargarUnidades();
    }, []);

    const cargarUnidades = () => {
        fetch(`${baseURL}/inventarioUnidadesGet.php`)
            .then(response => response.json())
            .then(data => setUnidades(data.unidades || []))
            .catch(error => console.error('Error:', error));
    };

    const abrirModalNuevo = () => {
        setUnidadActual({});
        setNombre('');
        setSimbolo('');
        setModalVisible(true);
    };

    const abrirModalEditar = (unidad) => {
        setUnidadActual(unidad);
        setNombre(unidad.nombre);
        setSimbolo(unidad.simbolo);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        setNombre('');
        setSimbolo('');
    };

    const guardarUnidad = () => {
        if (!nombre || !simbolo) {
            toast.error('Todos los campos son obligatorios');
            return;
        }

        if (unidadActual.idUnidadMedida) {
            // Editar
            const payload = { nombre, simbolo };
            fetch(`${baseURL}/inventarioUnidadesPut.php?idUnidadMedida=${unidadActual.idUnidadMedida}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Actualizado!', data.mensaje, 'success');
                        cargarUnidades();
                        cerrarModal();
                    }
                })
                .catch(error => toast.error(error.message));
        } else {
            // Crear
            const formData = new FormData();
            formData.append('nombre', nombre);
            formData.append('simbolo', simbolo);

            fetch(`${baseURL}/inventarioUnidadesPost.php`, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Creado!', data.mensaje, 'success');
                        cargarUnidades();
                        cerrarModal();
                    }
                })
                .catch(error => toast.error(error.message));
        }
    };

    const eliminarUnidad = (idUnidadMedida) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D83098',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/inventarioUnidadesDelete.php?idUnidadMedida=${idUnidadMedida}`, {
                    method: 'DELETE'
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            Swal.fire('Error', data.error, 'error');
                        } else {
                            Swal.fire('¡Eliminado!', data.mensaje, 'success');
                            cargarUnidades();
                        }
                    })
                    .catch(error => toast.error(error.message));
            }
        });
    };

    const unidadesFiltradas = unidades.filter(item =>
        item.nombre.toLowerCase().includes(filtro.toLowerCase()) ||
        item.simbolo.toLowerCase().includes(filtro.toLowerCase())
    );

    return (
        <div>
            <ToastContainer />

            <div className='deFlexContent'>
                <button className='btnPost' onClick={abrirModalNuevo}>
                    <FontAwesomeIcon icon={faPlus} /> Agregar Unidad
                </button>

                <div className='filtrosContain' style={{justifyContent: 'flex-end' }}>
                    <input
                        type="text"
                        placeholder="Buscar por nombre o símbolo"
                        value={filtro}
                        onChange={(e) => setFiltro(e.target.value)}
                        className='filtroInput'
                    />
                    
                </div>
            </div>

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <h3>{unidadActual.idUnidadMedida ? 'Editar Unidad' : 'Nueva Unidad'}</h3>
                            <span className="close" onClick={cerrarModal}>&times;</span>
                        </div>

                        <div className='flexGrap'>
                            <fieldset>
                                <legend>Nombre de la unidad</legend>
                                <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Ej: Kilogramo" />
                            </fieldset>
                            <fieldset>
                                <legend>Símbolo</legend>
                                <input type="text" value={simbolo} onChange={(e) => setSimbolo(e.target.value)} placeholder="Ej: kg" />
                            </fieldset>
                        </div>

                        <button className='btnPost' onClick={guardarUnidad}>Guardar</button>
                    </div>
                </div>
            )}

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre de la Unidad</th>
                            <th>Símbolo</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {unidadesFiltradas.map(item => (
                            <tr key={item.idUnidadMedida}>
                                <td>{item.idUnidadMedida}</td>
                                <td>{item.nombre}</td>
                                <td>{item.simbolo}</td>
                                <td>
                                    <button className='editar' onClick={() => abrirModalEditar(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <button className='eliminar' onClick={() => eliminarUnidad(item.idUnidadMedida)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}




